import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ResponseBase } from 'src/app/models/response-base';
import { Product } from '../../models/product/product-response.model';
import { api } from '../../services/api';
import { PRODUCTS_LIST } from '../contants';
import { getProductsError, getProductsSuccess } from './actions';

type fetchProductsParams = { payload: {assignorGuid: string, productCategory: number}, type: string };

export function* watchFetchProducts() {
  yield takeEvery(PRODUCTS_LIST, fetchProducts);
}

const fetchProductsAsync = async (assignorGuid: string, productCategory: number = 0) => 
  await api.get(`product/assignors/${assignorGuid}`, { params: { 'category': productCategory } })
    .then((response: any) => response)
    .catch((error: any) => error);


function* fetchProducts({ payload }: fetchProductsParams) {  
  try {
    const { assignorGuid, productCategory } = payload;
    const contracts: AxiosResponse<ResponseBase<Product[]>> = yield call(fetchProductsAsync, assignorGuid, productCategory);    
    
    if (contracts?.data?.status == 1) {
      yield put(getProductsSuccess(contracts?.data?.result));
    } else {
      yield put(getProductsError(contracts?.data?.message));
    }
  } catch (error) {
    yield put(getProductsError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchProducts)
  ]);
}